<style lang="less">
@import "./DevCenter.less";
</style>

<template>
  <div class="dev-center">

    <van-cell-group>
      <van-cell title="当前IMEI" icon="setting-o" :value="nowImei" is-link @click="toChangeDevPageFn" />
      <van-cell title="设备昵称" icon="label-o" :value="bdNickNameSet || '暂未设置'" is-link @click="setNickNameFn" />
      <!-- <van-cell title="车辆类型" icon="coupon-o" :value="bdCarType || '暂未设置'" is-link @click="selectCarTypeFn" /> -->
      <template v-if="bdCarType !== '电动车'">
        <van-cell title="汽车品牌" icon="bookmark-o" :value="bdCarBrandAndModel || '暂未设置'" is-link
          @click="selectCarBrandFn" />
        <van-cell title="车牌号码" icon="other-pay" :value="bdCarLicense || '暂未设置'" is-link @click="setCarLicenseFn" />
      </template>
    </van-cell-group>

    <div>
      <van-button class="long-btn margin-tb" type="info" size="large" @click="updateCarInfoFn">更新车辆信息</van-button>
    </div>

    <div class="dev-center-switch">
      <van-cell-group>
        <template v-for="item in settingItem">
          <van-cell :title="item.item" v-if="item.type === 'bool'">
            <van-switch :value="item.v"  size="24px" @change="(value)=>boolChange(value,item.cmd)" />
          </van-cell>
          <van-cell :title="item.item" v-if="item.type === 'enum'">
            <van-radio-group :value="item.v">
              <van-radio :name="i[0]"  @click="()=>radioGroupChange(i[0],item.cmd)" v-for="i in item.list">{{ i[1] }}</van-radio>
            </van-radio-group>
          </van-cell>


          <template v-if="item.type === 'progress'">
            <div class="dev-center-slider">
              <h3>{{ item.item }} <span style="font-size: 13px;color: #1989fa;">{{ item.special }}</span></h3>
              <van-slider :value="item.v" :min="item.list[0][1]" :max="item.list[1][1]"
              @input="(v)=>updateSettingItemValue(item.cmd,v)" @change="(value)=>sliderChange(value,item.cmd)" class="dev-center-shock">
                <div slot="button" class="custom-button">
                  {{ item.v }}
                </div>
              </van-slider>
            </div>
          </template>
          <template v-if="item.type === 'progress_split'">
            <div class="dev-center-slider">
              <h3>{{ item.item }}</h3>
              <ul class="dev-center-slider-time clear">
                <li>前({{ item.v }})</li>
                <li>后({{ item.list[1][1] - item.v }})</li>
              </ul>
              <van-slider :value="item.v" :min="item.list[0][1]" :max="item.list[1][1]"
              @input="(v)=>updateSettingItemValue(item.cmd,v)" @change="(value)=>sliderChange(value,item.cmd)" class="dev-center-front" />
            </div>
          </template>
        </template>
      </van-cell-group>
    </div>

    <div  class="margin-bx">
      <!-- <van-button  type="info" size="large" @click="updateDevInfoFn">更新设备设置</van-button> -->
    </div>

    <!-- 选择汽车类型 -->
    <van-action-sheet v-model="showActionSheetCarType" title="请选择汽车类型" round :actions="carTypeList" cancel-text="取消"
      @select="onSelectCarTypeFn" />

    <!-- 设置昵称-->
    <van-popup v-model="showPopupSetNickName" round position="bottom">
      <h3 class="popup-title">设置昵称</h3>
      <p class="popup-text">给设备设置一个好记的昵称吧，不能超过8个字哦</p>
      <div class="popup-con set-name">
        <van-field v-model="bdNickName" placeholder="请输入昵称" maxlength="8" />
        <van-button class="set-btn" type="info" size="large" @click="setNickNameSubmitFn">确定</van-button>
      </div>
      <div class="popup-cancel" @click="closePopupFn">取消</div>
    </van-popup>

    <!-- 设置车牌-->
    <van-popup v-model="showPopupCarLicense" round position="bottom">
      <h3 class="popup-title">设置车牌号码</h3>
      <div class="popup-con car-License">
        <div class="clear">
          <label @click="selectCarPlaceFn">{{ bdCarPlace || '归属地' }}</label>
          <van-field v-model="bdCarNumber" placeholder="车牌号码" />
        </div>
        <van-button class="set-btn" type="info" size="large" @click="setCarLicenseSubmitFn">确定</van-button>
      </div>
      <div class="popup-cancel" @click="closePopupFn">取消</div>
    </van-popup>

    <!-- 车牌归属-->
    <van-popup v-model="showPopupCarPlace" round position="bottom">
      <van-picker show-toolbar title="归属地" :columns="columnsCarPlace" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>

    <!-- 选择汽车品牌 分类选择器 -->
    <van-popup v-model="showPopupCarBrand" position="top">
      <van-tree-select :items="itemsCarBrand" :main-active-index="mainActiveIndex" :active-id="activeId"
        @click-nav="onClickNav" @click-item="onClickItem" />
    </van-popup>

  </div>
</template>

<script>
import DevCenter from './DevCenter.js'
export default {
  ...DevCenter
}
</script>
